import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import Subscribe from '../templates/Subscribe';
import Menu from '../templates/Menu';

import '../styles/index.sass';

class TemplateWrapper extends React.Component {
  constructor(props, ...args) {
    super(props, ...args);
    this.state = {
      visible: false,
    };
  }

  openMenu = () => {
    this.setState({
      visible: true,
    });
  };

  closeMenu = () => {
    this.setState({
      visible: false,
    });
  };

  renderNavBar = () => {
    const { location } = this.props;
    return (
      <ul className="sidebar__menu">
        <li className={GetActiveClass(location, '/')}>
          <Link onClick={this.closeMenu} to="/">
            Home
          </Link>
        </li>
        <li className={GetActiveClass(location, '/about')}>
          <Link onClick={this.closeMenu} to="/about">
            About
          </Link>
        </li>
      </ul>
    );
  };

  getPointerEvents = () => {
    if (!this.state.visible) {
      return null;
    }
    return { pointerEvents: 'none' };
  };

  renderFooter = mobileVersion => {
    const { children, data, location } = this.props;
    return (
      <div className={!mobileVersion ? 'sidebar__footer' : 'sidebar__footer__mobile'}>
        <p className="sidebar__social">
          {data.allDatoCmsSocialProfile.edges.map(({ node: profile }) => (
            <a
              key={profile.profileType}
              href={profile.url}
              target="blank"
              className={`social social--${profile.profileType.toLowerCase()}`}
            />
          ))}
        </p>
        <div className="sidebar__copyright">{data.datoCmsHome.copyright}</div>
      </div>
    );
  };

  render() {
    const { children, data, location } = this.props;
    return (
      <div className="container">
        <HelmetDatoCms
          favicon={data.datoCmsSite.faviconMetaTags}
          seo={data.datoCmsHome.seoMetaTags}
        />
        <div className="container__sidebar">
          <div className="sidebar">
            <h6 className="sidebar__title">
              <Link to="/">{data.datoCmsSite.globalSeo.siteName}</Link>
            </h6>
            <div
              className="sidebar__intro"
              dangerouslySetInnerHTML={{
                __html: data.datoCmsHome.introTextNode.childMarkdownRemark.html,
              }}
            />
            {this.renderNavBar()}

            <Subscribe />
            {this.renderFooter(false)}
          </div>
        </div>
        <div className="container__body">
          <Menu visible={this.state.visible} onChange={this.closeMenu} alignment="left">
            {this.renderNavBar()}
            <Subscribe />
            {this.renderFooter(true)}
          </Menu>
          <div className="container__mobile-header">
            <div className="mobile-header">
              <div className="mobile-header__menu">
                <button className="open-btn" onClick={this.openMenu}>
                  &#9776;
                </button>
              </div>
              <div className="mobile-header__logo">
                <Link to="/">{data.datoCmsSite.globalSeo.siteName}</Link>
              </div>
            </div>
            <div />
          </div>
          <div style={this.getPointerEvents()}>{children()}</div>
        </div>
      </div>
    );
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;

export const GetActiveClass = (location, locationToCheck) =>
  location.pathname === locationToCheck && 'is-active';

export const query = graphql`
  query LayoutQuery {
    datoCmsSite {
      globalSeo {
        siteName
      }
      faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
    }
    datoCmsHome {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      introTextNode {
        childMarkdownRemark {
          html
        }
      }
      copyright
    }
    allDatoCmsSocialProfile(sort: { fields: [position], order: ASC }) {
      edges {
        node {
          profileType
          url
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js